import { useRef, useEffect, useState } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import historias from "../../historias";
import normalizeString from "../../utilities/function/normalizeString";
import MicroModal from "micromodal";
import ModalThumb from "./ModalThumb";
import useIsMobile from '../../utilities/function/useIsMobile';

/*componentes */
import Header from "../globales/Header";
import FichaTecnica from "./FichaTecnica";
import Historia from "./Historia";
import IntroHistoria from "./IntroHistoria";
import MenuLateral from "./MenuLateral";
import PortadaHistoria from "./PortadaHistoria";
import Video from "./Video";

const Contenido = () => {
  const [anchoTituloEstatico, setAnchoTituloEstatico] = useState('');
  const isMobile = useIsMobile();

  const tituloEstatico = useRef(null);
  const refIntroHistoria = useRef(null);
  const refHistoria = useRef(null);
  const params = useParams();

  const findHistoria = () => {
    let item = historias.find(item => normalizeString(item.titulo) === params.page);
    return item;
  }

  const [historia, setHistoria] = useState(findHistoria());
  const { titulo, ciudad, departamento, video, contenido, introduccion, institucion, tipoInstitucion, caracteristicas, totalEstudiantes, equipoLider, datoExtra, grados, imagen } = historia;

  useEffect(() => {
    if (!!tituloEstatico) {
      actualizarAlto();
      window.addEventListener('resize', actualizarAlto);
      return () => {
        window.removeEventListener('resize', actualizarAlto);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [anchoTituloEstatico, tituloEstatico])

  useEffect(() => {
    setHistoria(findHistoria())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params])

  const actualizarAlto = () => {
    const nuevaAltura = tituloEstatico.current.scrollWidth;
    setAnchoTituloEstatico(nuevaAltura);
  }

  const navegacion = () => {
    let index = historias.findIndex(item => normalizeString(item.titulo) === params.page);
    let positionSiguiente = index + 1;
    let positionAnterior = index - 1;
    let navegacion = {
      prev: null,
      next: null
    }

    if (positionAnterior < 0) {
      navegacion.prev = {
        name: historias[historias.length - 1].titulo,
        ciudad: historias[historias.length - 1].ciudad,
        departamento: historias[historias.length - 1].departamento,
        link: normalizeString(historias[historias.length - 1].titulo)
      }
    }

    if (positionAnterior >= 0) {
      navegacion.prev = {
        name: historias[positionAnterior].titulo,
        ciudad: historias[positionAnterior].ciudad,
        departamento: historias[positionAnterior].departamento,
        link: normalizeString(historias[positionAnterior].titulo)
      }
    }
    if (positionSiguiente <= historias.length - 1) {
      navegacion.next = {
        name: historias[positionSiguiente].titulo,
        ciudad: historias[positionSiguiente].ciudad,
        departamento: historias[positionSiguiente].departamento,
        link: normalizeString(historias[positionSiguiente].titulo)
      }
    }
    if (positionSiguiente === historias.length) {
      navegacion.next = {
        name: historias[0].titulo,
        ciudad: historias[0].ciudad,
        departamento: historias[0].departamento,
        link: normalizeString(historias[0].titulo)
      }
    }

    return navegacion
  }

  return (
    <>
      <MenuLateral />
      <div className="h-auto lg:bg-transparent fixed w-full z-50 lg:h-28 flex">
        <Header />
      </div>



      <PortadaHistoria textoHistoria={historia} elementoIntroHistoria={refIntroHistoria} />

      <div
        ref={refIntroHistoria}
        className=" relative flex items-start"
      >
        <div
          ref={tituloEstatico}
          className={isMobile ? 'hidden' : 'sticky top-0 w-80 '}
        >
          <div
            className='w-40 xl:w-48 mt-36 ml-5 xl:ml-12 bg-blanco p-2 cursor-pointer'
            onClick={() => {
              MicroModal.show('modal-imagen', {
                awaitCloseAnimation: true
              })
            }}>
            <img src={require(`../../images/thumbs/${imagen}`).default} alt="ilustración de la historia" />
          </div>
          <div className="w-44 xl:w-60 md:bg-blanco md:bg-opacity-60 md:mt-5">
            <div className="w-40 ml-3 xl:ml-12 px-3 py-5 ">
              <p className="poppins-700 pb-3">{titulo} </p>
              <hr />
              <p className="poppins-300 alineado-verticalmente pt-3" ><span className="icon-ubicacion mr-3"></span> {ciudad}, {departamento} </p>
            </div>
          </div>
        </div>


        <div style={{ marginLeft: -(anchoTituloEstatico) }}>
          <IntroHistoria introTexto={introduccion} inicioHistoria={refHistoria} />

          <div id="pruebaHistoria" ref={refHistoria}>
            <div
              className="p-10 bg-blanco cursor-pointer lg:hidden"
              onClick={() => {
                MicroModal.show('modal-imagen', {
                  awaitCloseAnimation: true
                })
              }}>
              <img
                className="max-w-60 mx-auto"
                src={require(`../../images/thumbs/${imagen}`).default}
                alt="ilustración de la historia"
              />
            </div>


            <Historia
              contenido={contenido}
              ciudad={ciudad}
              departamento={departamento}
              titulo={titulo}
            />
          </div>

          <FichaTecnica
            caracteristicas={caracteristicas}
            ciudad={ciudad}
            datoExtra={datoExtra}
            departamento={departamento}
            equipoLider={equipoLider}
            grados={grados}
            institucion={institucion}
            tipoInstitucion={tipoInstitucion}
            totalEstudiantes={totalEstudiantes}
          />

          {
            video &&
            <Video video={video} />
          }

          <div className="w-10/12 lg:w-7/12 mx-auto my-10">
            <div className="flex justify-between items-center lg:items-end">
              <div className=" lg:w-6/12 mr-5">
                {
                  navegacion().prev &&
                  <Link
                    className="block text-gris-c4 hover:text-gris-66"
                    to={navegacion().prev.link}
                  >
                    <div className="flex justify-between items-center border-b py-3">
                      <span className="icon-izquierda text-20"></span>
                      <p className={`${isMobile && 'ml-5'} poppins-700 text-right`}>{isMobile ? 'Anterior': navegacion().prev.name}</p>
                    </div>
                    <p className="hidden lg:block text-right poppins-300 py-3">{navegacion().prev.ciudad} - {navegacion().prev.departamento} </p>
                  </Link>
                }
              </div>
              <div className="lg:w-6/12 ml-5">
                {
                  navegacion().next !== null &&
                  <Link
                    className="block text-gris-c4 hover:text-gris-66"
                    to={navegacion().next.link}
                  >
                    <div className="flex justify-between items-center border-b py-3">
                      <p className={`${isMobile && 'mr-5'} poppins-700`}>{isMobile ? 'Siguiente': navegacion().next.name}</p>
                      <span className="icon-derecha text-20"></span>
                    </div>
                    <p className="hidden lg:block  poppins-300 py-3 ">{navegacion().next.ciudad} - {navegacion().next.departamento} </p>
                  </Link>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalThumb nombreModal="modal-imagen" thumb={imagen} />



    </>
  )
}

export default Contenido;